export default __webpack_public_path__ + "static/media/anwb.516e23ef.svg";